import createItemFetcher from "../helpers/item";
import { createUseFetch } from "../helpers/fetchHooks";
const fileVersions = createItemFetcher(({ scenario, workspace, program, mode, panel }) => `/api/v1/ascii/${scenario}/${workspace}/${program}/${mode}/${panel}/versions`, "FILE_VERSIONS", ({ scenario, workspace, program, mode, panel }) => `${scenario}_${workspace}_${program}_${mode}_${panel}`);
export const createFileVersions = () => {
    return fileVersions;
};
export const useFileVersions = createUseFetch(fileVersions, state => state.fileVersions);
const fileVersionsItem = createItemFetcher(({ scenario, workspace, program, mode, panel, id }) => `/api/v1/ascii/${scenario}/${workspace}/${program}/${mode}/${panel}/versions/${id}`, "FILE_VERSIONS_ITEM", ({ scenario, workspace, program, mode, panel, id }) => `${scenario}_${workspace}_${program}_${mode}_${panel}_${id}`);
export const createFileVersionsItem = () => {
    return fileVersionsItem;
};
export const useFileVersionsItem = createUseFetch(fileVersionsItem, state => state.fileVersionsItem);
//# sourceMappingURL=versions.js.map